class RequestAbortedError extends Error {
    constructor() {
        super('The request was aborted.');
    }
}

module.exports = RequestAbortedError;
